export const getAdminConfigState = (state) => state.adminConfig.trafficStatusConfig;
export const getLoadingAdminConfigState = (status) => status.adminConfig.loadingTrafficStatusConfig;